import checklistsurveyunconfirmedRepository from '@/shared/http/repositories/business/checklistsurveychecklistsurveyunconfirmed'
import checklistsurveychecklistsurveyRepository from '@/shared/http/repositories/business/checklistsurveychecklistsurvey'
import cheacklistsurveyRepository from '@/shared/http/repositories/business/cheacklistsurvey'
import { loading } from '@/shared/utils/UIHelper'

export default {
  props: ['dataCheckForm', 'idvistoria', 'codigo'],
  name: 'checklisttableComponent',
  data () {
    return {
      dataCheck: [],
      dataModal: [],
      titleModal: null,
      dataCheckAll: [],
      listCheck: [],
      notConform: false,
      Enum: [],
      checkVistoria: [],
      checkstatus: null,
      statusModal: false,
      statusModalCheck: false
    }
  },
  filters: {
    filterEnum: function (value) {
      if (value === null) return ''
      if (value === 'SAUDE_E_SEGURANCA') return 'SAÚDE E SEGURANÇA'
      if (value === 'ESCRITORIO') return 'ESCRITÓRIO'
      if (value === 'REFEITORIO') return 'REFEITÓRIO'
      if (value === 'VESTIARIO') return 'VESTIÁRIO'
      if (value === 'ARMACAO') return 'ARMAÇÃO'
      if (value === 'LAVATORIOS') return 'LAVATÓRIOS'
      value = value.toString()
      value = value.split('_').join(' ')
      return value
    }
  },
  // changeStatus (value) {
  //   loading.push()
  //   SurveyRepository.ChangeStatusVistoria(this.dataDetails.id, value)
  //     .then(Response => {
  //       this.dataDetails.statusvistoria = Response.data.data.statusvistoria
  //       loading.pop()
  //       this.formatStatusVistoria(this.dataDetails.statusvistoria)
  //     })
  //     .catch(Error => this.onException(Error))
  // },
  created () {
    // this.GetCheckListVistoria(this.idvistoria)
    this.GetCheckList()
    this.getEnumCheckList()
    this.getListCheckList(this.idvistoria)
  },
  methods: {
    showModal (obj) {
      this.dataModal = this.dataCheckAll.filter((Element) => Element.tipo === parseInt(obj.value))
      this.checkstatus = this.checkVistoria.filter((Element) => Element.tipo === parseInt(obj.value))
      if (this.checkstatus.length === 0) {
        this.statusModalCheck = true
      } else {
        this.statusModalCheck = false
      }
      this.titleModal = obj.text
      this.$refs['modal-checklist'].show()
    },
    getListCheckList (id) {
      loading.push()
      checklistsurveychecklistsurveyRepository.GetByVistoriaId(id)
        .then(Response => {
          this.checkVistoria = Response.data.data
          loading.pop()
        })
        .catch(Error => this.onException(Error))
    },
    Chekarlista (value) {
      if (this.checkstatus.length === 0) return false
      if (this.checkstatus[0].conforme === false) {
        if (this.checkstatus[0].vistoriaChecklistSupervisaoInconformidade.length > 0) {
          let verificarCheckVistoria = this.checkstatus[0].vistoriaChecklistSupervisaoInconformidade.filter((Element) => Element.checklistSupervisaID === value)
          if (verificarCheckVistoria.length > 0) {
            return true
          } else {
            return false
          }
        } else {
          return true
        }
      }
      return false
    },
    back () {
      window.location.reload()
    },
    GetCheckListVistoria (id) {
      checklistsurveyunconfirmedRepository.GetByVistoria(id)
        .then(Response => {
          this.dataCheck = Response.data.data
        })
        .catch(Error => this.onException(Error))
    },
    getEnumCheckList () {
      cheacklistsurveyRepository.GetEnum()
        .then(Response => {
          this.Enum = Response.data
        })
        .catch(Error => this.onException(Error))
    },
    testeCheck (value) {
      var teste = this.checkVistoria.filter((Element) => Element.tipo === parseInt(value) && Element.conforme === false)
      if (teste == null) return true
      if (teste.length > 0) return true
      return false
    },
    GetCheckList () {
      cheacklistsurveyRepository.GetAll()
        .then(Response => {
          this.dataCheckAll = Response.data.data
        })
        .catch(Error => this.onException(Error))
    },
    hideModal () {
      this.$refs['modal-checklist'].hide()
    },
    setConform () {
      this.notConform = false
    },
    setFalseNotConform () {
      this.notConform = true
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/Survey/components/checklist/checklisttable.js